module.exports = __webpack_public_path__ + "resources/img/img_magic_eam_m.7fe19cc8117d0e6a14d47c449d366300.png";